import _ from 'lodash-es'
import { configVars } from '../../../data'
import { DeviceDataType } from '../device-types'
import { getEnvironmentFromUrl } from '../../../utils'
import { DeviceTypeEnum } from '../../../data/enums'

export const getIpFromDeviceConfig = (device: DeviceDataType) =>
    _.get(device, 'config.diff.networking.wireguard.interface.ip')
export const getBalenaUrl = (deviceId: string) => configVars.balenaDashbordUrl.replace('deviceId', deviceId)

export const getCameraUrl = (device: DeviceDataType): string | null | undefined => {
    const ip = getIpFromDeviceConfig(device)
    if (!ip) {
        return null
    }
    return configVars.cameraUrl.replace('IP', ip)
}
export const getRouterUrl = (device: DeviceDataType): string | null | undefined => {
    const ip = getIpFromDeviceConfig(device)

    if (!ip) {
        return null
    }
    return configVars.routerUrl.replace('IP', ip)
}
export const getWatchdogUrl = (device: DeviceDataType): string | null | undefined => {
    const ip = getIpFromDeviceConfig(device)
    if (!ip) {
        return null
    }
    return configVars.watchdogUrl.replace('IP', ip)
}
export const getLiveViewUrl = (device: DeviceDataType): string | null | undefined => {
    const ip = getIpFromDeviceConfig(device)
    // console.log(ip, 'ip', configVars.liveViewUrl.replace('IP', ip))
    if (!ip) {
        return null
    }
    return configVars.liveViewUrl.replace('IP', ip)
}

export const getTelktonikaRmsUrl = (deviceName: string | null): string | null | undefined => {
    if (!deviceName) {
        return null
    }
    return configVars.telktonikaRmsUrl.replace('DEVICE_NAME', deviceName)
}

export const getElasticLogsUrl = (deviceUuid: string | null, deviceType: DeviceTypeEnum): string | null | undefined => {
    const environment = getEnvironmentFromUrl()
    if (!deviceUuid) {
        return null
    }

    if (environment === 'prod') {
        if (deviceType === DeviceTypeEnum.TERMINAL) {
            return configVars.elasticLogsTerminalProd.replace('DEVICE_UUID', deviceUuid)
        } else if (deviceType === DeviceTypeEnum.DISPLAY) {
            return configVars.elasticLogsScreenProd.replace('DEVICE_UUID', deviceUuid)
        } else return configVars.elasticLogsUrlProd.replace('DEVICE_UUID', deviceUuid)
    } else {
        if (deviceType === DeviceTypeEnum.TERMINAL) {
            return configVars.elasticLogsTerminal.replace('DEVICE_UUID', deviceUuid)
        } else if (deviceType === DeviceTypeEnum.DISPLAY) {
            return configVars.elasticLogsScreen.replace('DEVICE_UUID', deviceUuid)
        } else return configVars.elasticLogsUrl.replace('DEVICE_UUID', deviceUuid)
    }
}
